import actions from './actions'
import mutations from './mutations'

export interface State {
  logined: boolean
}

const initialState: State = {
  logined: false,
}

export default {
  state: initialState,
  getters: {
    isLogined(state: State) {
      return state.logined
    },
  },
  actions,
  mutations,
}
